import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  ChakraProvider,
  useToast,
  Select,
  HStack,
  Divider,
  Spacer,
} from '@chakra-ui/react';
import { AppDispatch, Store } from '../Store/StoreInit';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { fetchPayerAddressList } from '../Store/GetDropDownsValuesReducer';
import { useMsal } from '@azure/msal-react';
import {
  IPayerAddressItem,
  IPayerMasterItem,
} from '../Infrastructure/Interfaces';

interface Props {
  isOpen?: any;
  onOpen?: any;
  onClose?: any;
}

const PayerAddressModalPopup: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const toast = useToast();
  const { accounts } = useMsal();
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;
  var payerAddresslist: IPayerAddressItem[] = useSelector((state: any) => {
    return state.payerAddressList.payerAddressList;
  });
  const payermasterlist: IPayerMasterItem[] = useSelector((state: any) => {
    return state.payerMasterList.payerMasterList;
  });
  const [activePayerMasterList, setActivePayerMasterList] = useState<
    IPayerMasterItem[]
  >([]);

  useEffect(() => {
    setActivePayerMasterList(payermasterlist.filter(x => x.isActive === true));
  }, [payermasterlist]);

  const [isAddressReq, setIsAddressReq] = useState(false);
  const [isCityReq, setIsCityReq] = useState(false);
  const [isStateReq, setIsStateReq] = useState(false);
  const [isZipReq, setIsZipReq] = useState(false);

  const [data, setdata] = useState({
    payerAddressId: 0,
    payerMasterId: 0,
    payerName: '',
    payerId: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    phoneNo: '',
    faxNo: '',
    isActive: true,
    createdBy: userid,
    createdOn: '0001-01-01T00:00:00',
    modifiedBy: userid,
    modifiedOn: '0001-01-01T00:00:00',
  });

  useEffect(() => {
    Store.subscribe(() => {
      setIsZipReq(false);
      setIsStateReq(false);
      setIsCityReq(false);
      setIsAddressReq(false);
      setdata({
        ...data,
        payerAddressId: Store.getState().payerAddressItem.value.payerAddressId,
        payerMasterId: Store.getState().payerAddressItem.value.payerMasterId,
        payerName: Store.getState().payerAddressItem.value.payerName,
        payerId: Store.getState().payerAddressItem.value.payerId,
        address: Store.getState().payerAddressItem.value.address,
        city: Store.getState().payerAddressItem.value.city,
        state: Store.getState().payerAddressItem.value.state,
        zip: Store.getState().payerAddressItem.value.zip,
        phoneNo: Store.getState().payerAddressItem.value.phoneNo,
        faxNo: Store.getState().payerAddressItem.value.faxNo,
        isActive: Store.getState().payerAddressItem.value.isActive,
        createdBy: Store.getState().payerAddressItem.value.createdBy,
        createdOn: Store.getState().payerAddressItem.value.createdOn,
        modifiedBy: userid,
        modifiedOn: Store.getState().payerAddressItem.value.modifiedOn,
      });
    });
  }, []);

  const handleChange = (e: any) => {
    e.preventDefault();
    const { id, value } = e.target;
    setdata({
      ...data,
      [id]: value,
    });
  };

  useEffect(() => {
    var payerid = payerAddresslist.find(x => x.payerName == data.payerName)
      ?.payerId!;
    setdata(prev => ({ ...prev, payerId: payerid }));
  }, [data.payerName]);

  async function handleSubmit(e: { preventDefault: () => void }) {
    e.preventDefault();

    const validationError = validateData(data);
    if (!validationError) {
      return;
    }

    if (data.payerMasterId > 0) {
      const item: any = payerAddresslist.find(
        x =>
          x.payerMasterId === data.payerMasterId &&
          x.address === data.address.trim() &&
          x.zip === data.zip.trim()
      );

      if (item && item.payerAddressId !== data.payerAddressId) {
        showToast(
          'Error!',
          'This Payer address/zip combination already exists. Please use a different address/zip.',
          'error'
        );
        return;
      }
    }

    setSaveButtonLoading(true);

    const payload = {
      payerAddressId: data.payerAddressId,
      payerMasterId: data.payerMasterId,
      payerName: data.payerName,
      payerId: data.payerId,
      address: data.address.trim(),
      city: data.city.trim(),
      state: data.state.trim(),
      zip: data.zip,
      phoneNo: data.phoneNo,
      faxNo: data.faxNo,
      isActive: data.isActive,
      createdBy: userid,
      createdOn: '0001-01-01T00:00:00',
      modifiedBy: userid,
      modifiedOn: '0001-01-01T00:00:00',
    };

    const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;
    const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;

    try {
      const res = await axios.get(tokenurl);
      if (res.data.success) {
        const url = `${baseurl}/Payer/${
          data.payerAddressId > 0 ? 'update_payeraddress' : 'add_payeraddress'
        }`;

        const axiosMethod = data.payerAddressId > 0 ? axios.put : axios.post;

        const response = await axiosMethod(url, JSON.stringify(payload), {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${res.data.token}`,
          },
        });

        setSaveButtonLoading(false);
        dispatch(fetchPayerAddressList());
        props.onClose();

        if (response.data.success) {
          showToast('Success', response.data.message, 'success');
        }
      }
    } catch (error: any) {
      setSaveButtonLoading(false);
      showToast(
        'Error!',
        error.response.data.message || error.message,
        'error'
      );
    }
  }

  function validateData(data: any) {
    const fields = ['address', 'city', 'state', 'zip'];
    let isValid = true;

    fields.forEach(field => {
      const isFieldEmpty = data[field].trim() === '';
      if (isFieldEmpty) {
        isValid = false;
      }

      switch (field) {
        case 'address':
          setIsAddressReq(isFieldEmpty);
          break;
        case 'city':
          setIsCityReq(isFieldEmpty);
          break;
        case 'state':
          setIsStateReq(isFieldEmpty);
          break;
        case 'zip':
          setIsZipReq(isFieldEmpty);
          break;
      }
    });
    return isValid;
  }

  function showToast(
    title: string,
    description: string,
    status: 'error' | 'success'
  ) {
    toast({
      title,
      description,
      position: 'top',
      status,
      duration: status === 'error' ? 10000 : 5000,
      isClosable: true,
    });
  }

  return (
    <>
      <ChakraProvider>
        <Modal
          closeOnOverlayClick={false}
          size={'3xl'}
          isOpen={props.isOpen}
          onClose={props.onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <form onSubmit={handleSubmit}>
              <ModalHeader fontWeight="bold">
                <u>Payer Address</u>
              </ModalHeader>
              <ModalCloseButton color="black" />{' '}
              <ModalBody>
                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Payer Name:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="payerMasterId"
                      id="payerMasterId"
                      defaultValue={data.payerMasterId}
                      onChange={e => handleChange(e)}
                    >
                      {activePayerMasterList.map(_payername => (
                        <option
                          key={_payername.payerMasterId}
                          value={_payername.payerMasterId}
                        >
                          {_payername.payerName}
                        </option>
                      ))}
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired isInvalid={isAddressReq}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Address:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={200}
                      placeholder="Address"
                      name="address"
                      id="address"
                      defaultValue={data.address}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired isInvalid={isCityReq}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      City:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={50}
                      placeholder="City"
                      name="city"
                      id="city"
                      defaultValue={data.city}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired isInvalid={isStateReq}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      State:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={50}
                      placeholder="State"
                      name="state"
                      id="state"
                      defaultValue={data.state}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired isInvalid={isZipReq}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Zip:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={12}
                      type="text"
                      placeholder="Zip"
                      name="zip"
                      id="zip"
                      defaultValue={data.zip}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Phone No:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={12}
                      type="text"
                      placeholder="phone No"
                      name="phoneNo"
                      id="phoneNo"
                      defaultValue={data.phoneNo}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2}>
                  <HStack>
                    <FormLabel fontWeight="bold" width="30%">
                      Fax No:
                    </FormLabel>
                    <Input
                      size="sm"
                      maxLength={10}
                      type="number"
                      placeholder="Fax No"
                      name="faxNo"
                      id="faxNo"
                      defaultValue={data.faxNo}
                      onChange={e => handleChange(e)}
                    />
                  </HStack>
                </FormControl>
                <Divider mt={2} />

                <FormControl mt={2} isRequired>
                  <HStack>
                    <FormLabel width="30%" fontWeight="bold">
                      Active:
                    </FormLabel>
                    <Select
                      size="sm"
                      placeholder="--select--"
                      name="isActive"
                      id="isActive"
                      defaultValue={
                        data.isActive == true
                          ? 'true'
                          : data.isActive == false
                          ? 'false'
                          : ''
                      }
                      onChange={e => handleChange(e)}
                    >
                      <option value="true">True</option>
                      <option value="false">False</option>
                    </Select>
                  </HStack>
                </FormControl>
                <Divider mt={2} />
              </ModalBody>
              <ModalFooter>
                <Button bg="#002677" color="white" onClick={props.onClose}>
                  Cancel
                </Button>
                <Spacer />
                <Button
                  isLoading={saveButtonLoading}
                  bg="#002677"
                  color="white"
                  mr={3}
                  type="submit"
                  //onClick={(e) => handleSubmit(e)}
                >
                  Save
                </Button>
              </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      </ChakraProvider>
    </>
  );
};

export default PayerAddressModalPopup;
